import { UseFormReturnType, isNotEmpty, useForm } from '@mantine/form'
import { modals } from '@mantine/modals'
import { notifications } from '@mantine/notifications'

import { useCreateEmailDomainMutation } from '../api/emailDomain.api'
import { ICreateEmailDomain } from '../emailDomain.types'

export interface ICreateEmailDomianUseCase {
  form: UseFormReturnType<ICreateEmailDomain>
  onSubmit: () => void
  isLoading: boolean
}

const createEmailDomainUseCase = (): ICreateEmailDomianUseCase => {
  const [createEmailDomainMutation, { isLoading }] =
    useCreateEmailDomainMutation()

  const form = useForm<ICreateEmailDomain>({
    mode: 'uncontrolled',
    initialValues: {
      domain: '',
      isWBFRegister: false,
    },
    validateInputOnBlur: true,
    validate: {
      domain: isNotEmpty('Domain is required!'),
    },
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      createEmailDomainMutation(values)
        .unwrap()
        .then(() => {
          modals.closeAll()
          notifications.show({
            title: 'Success',
            message: 'Email domain successfully created',
          })
        })
        .catch(() => {
          notifications.show({
            title: 'Error',
            message: 'There was an error to create email domain',
            color: 'red',
          })
        })
    })()
  }

  return {
    form,
    onSubmit,
    isLoading,
  }
}

export default createEmailDomainUseCase
